"use strict";
var __importStar =
  (this && this.__importStar) ||
  function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
Object.defineProperty(exports, "__esModule", { value: true });
const IValidation_1 = require("./IValidation");
const Yup = __importStar(require("yup"));
const helper_1 = require("./helper");
const objectSchema = Yup.object()
  .shape({
    action: Yup.string().required(),
    params: Yup.mixed()
  })
  .required();
class VmwareActionNodeValidation {
  validate(node) {
    let data = node.getNodeData();
    let selectedResource = node.getSelectedResource();
    return helper_1.isValid(
      [
        { schema: objectSchema, data },
        { schema: IValidation_1.nodeSchema, data: node.serializeNode() },
        { schema: IValidation_1.selectedResourceSchema, data: selectedResource }
      ],
      node.getNodeId()
    );
  }
}
exports.VmwareActionNodeValidation = VmwareActionNodeValidation;
//# sourceMappingURL=VmwareActionNodeValidation.js.map
